module.exports = [
  {
    "name": "defense",
    "description": "a defensive action"
  },

  {
    "name": "offense",
    "description": "an attack"
  },

  {
    "name": "lead",
    "description": "on lead side (left for orthodox, right for southpaw)"
  },

  {
    "name": "rear",
    "description": "on rear side (right for orthodox, left for southpaw"
  },

  {
    "name": "head",
    "description": "action involving the head and/or shoulders"
  },

  {
    "name": "body",
    "description": "action involving the chest and/or hips"
  }
]